import type { TierInfo } from '@/hooks/useTier';
import { formatReais } from '@/lib/utils';

const TIER_COLORS: Record<string, string> = {
  bronze: 'bg-amber-700 text-white dark:bg-amber-800',
  silver: 'bg-gray-400 text-white dark:bg-gray-500',
  gold: 'bg-yellow-500 text-white dark:bg-yellow-600',
  lead_qual: 'bg-purple-600 text-white dark:bg-purple-700',
};

// Sem centavos: aqui o número é ordem de grandeza, não valor exato.
const formatReaisSemCentavos = (value: number) => formatReais(value, { hideCents: true });

export function TierProgress({ tierInfo, onUpgradeClick }: { tierInfo: TierInfo; onUpgradeClick?: () => void }) {
  const colorClass = TIER_COLORS[tierInfo.current] ?? TIER_COLORS['bronze'];
  const hasNext = tierInfo.nextTier && tierInfo.nextTierSpendBrl;
  const progress = hasNext
    ? Math.min(100, (tierInfo.totalSpendBrl / tierInfo.nextTierSpendBrl!) * 100)
    : 100;

  return (
    <div className="flex items-center gap-4">
      <span className={`inline-flex items-center rounded-md px-2.5 py-1 text-xs font-bold uppercase ${colorClass}`}>
        {tierInfo.label}
      </span>

      {hasNext ? (
        <div className="flex flex-1 items-center gap-3">
          <div className="flex-1">
            <div className="h-2 w-full rounded-full bg-muted">
              <div
                className="h-2 rounded-full bg-primary transition-all duration-500"
                style={{ width: `${progress}%` }}
              />
            </div>
            <p className="mt-1 text-xs text-muted-foreground">
              {formatReaisSemCentavos(tierInfo.totalSpendBrl)} / {formatReaisSemCentavos(tierInfo.nextTierSpendBrl!)} para{' '}
              <span className="font-semibold capitalize">{tierInfo.nextTier}</span>
              {tierInfo.spendRemaining != null && tierInfo.spendRemaining > 0 && (
                <> — faltam {formatReaisSemCentavos(tierInfo.spendRemaining)}</>
              )}
            </p>
          </div>
          {onUpgradeClick && (
            <button
              onClick={onUpgradeClick}
              className="whitespace-nowrap rounded-md border border-border px-3 py-1.5 text-xs font-medium transition-colors hover:bg-muted"
            >
              Solicitar upgrade
            </button>
          )}
        </div>
      ) : (
        <span className="text-xs text-muted-foreground">Plano máximo</span>
      )}
    </div>
  );
}
